export const loginModal = {
  loginEmail: "Voer asseblief jou e-pos in!",
  loginUserName: "Voer asseblief jou gebruikersnaam in!",
  loginPassword: "Voer asseblief jou wagwoord in!",
  loginForgotPassword: "Wagwoord vergeet?",
  loginPasswordRecoverTitle: "Wagwoordherwinning",
  loginPasswordRecover: "Wagwoordherwinning suksesvol",
  loginPasswordRecoverMsg: "Kontroleer jou e-pos om jou wagwoord terug te stel",
  loginNoAccount: "Het jy nie 'n rekening nie?",
  loginRegister: "Teken in",
  loginUserNotFound: "Gebruiker nie gevind nie",
  loginIncorrectPasswordEmail: "Gebruiker of wagwoord is nie geldig nie",
  loginSendBtn: "Stuur",
  loginSessionTitle: "Teken in",
  loginEmailPlaceholder: "E-pos",
  loginEmailLocalPartPlaceholder: "gebruikersnaam",
  loginEmailDomainOther: "Ander",
  loginEmailCustomDomainPlaceholder: "domein.com",
  loginPasswordPlaceholder: "Wagwoord",
  loginRecoverEmail:
    "Onthou jy nie die e-pos waarmee jy geregistreer het nie? Herwin jou rekening deur ons ondersteuningspan te kontak.",
  loginSupport: "Tegniese ondersteuning",
  loginRememberEmail: "Onthou my e-pos",
  loginWithGoogle: "Gaan voort met Google",
  loginOrDivider: "of",
  googleLoginError: "Kon nie met Google inteken nie. Probeer asseblief weer.",
  googleNewUserRegister: "Jou Google-rekening is nuut. Registreer eers om voort te gaan.",
};
